import u, { useState as _ } from "react";
import { useTheme as P, Select as H, Autocomplete as N, TextField as k, Box as j, Tooltip as B } from "@mui/material";
import { C as M } from "./chunk.axyDoYhW.js";
import { jsx as U } from "react/jsx-runtime";
import { createSvgIcon as G } from "@mui/material/utils";
import { K } from "./chunk.ChMTXB4R.js";
import X from "@mui/material/InputLabel";
import Z from "@mui/material/FormControl";
import J from "@mui/material/FormHelperText";
import { M as R } from "./chunk.DVkl1685.js";
import { g as q } from "./chunk.CKXGCgA0.js";
import { I as D } from "./chunk.6lzLxMfL.js";
const Q = G(/* @__PURE__ */ U("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function $({
  option: t,
  multiple: e,
  handleMenuItemClick: l,
  elementProps: d,
  labelNode: s,
  descriptionNode: o
}) {
  return typeof t == "string" ? /* @__PURE__ */ u.createElement(
    R,
    {
      key: t,
      value: t,
      label: t,
      labelNode: s,
      variant: e ? "checkbox" : "checkmark",
      onClick: l == null ? void 0 : l(t),
      ...d
    }
  ) : e && "endIcon" in t && t.endIcon ? /* @__PURE__ */ u.createElement(
    R,
    {
      value: t.value,
      label: t.label,
      labelNode: s,
      description: t.description,
      descriptionNode: o,
      startElement: t.startElement,
      endIcon: t.endIcon,
      "data-testid": t["data-testid"],
      variant: e ? "checkbox" : "checkmark",
      onClick: l == null ? void 0 : l(t.value),
      ...d,
      key: t.value
    }
  ) : /* @__PURE__ */ u.createElement(
    R,
    {
      value: t.value,
      label: t.label,
      labelNode: s,
      description: t.description,
      descriptionNode: o,
      startElement: t.startElement,
      endText: t.endText,
      "data-testid": t["data-testid"],
      variant: e ? "checkbox" : "checkmark",
      onClick: l == null ? void 0 : l(t.value),
      ...d,
      key: t.value
    }
  );
}
function me({
  size: t = "default",
  ...e
}) {
  var I, w, y, L, E, F, V, g, C, a, n, r;
  const l = P(), d = e.autosuggest, s = e.menuItems && e.menuItems.length > 0 && typeof e.menuItems[0] == "string", o = {
    ...e
  }, b = (y = (w = (I = l.components) == null ? void 0 : I.SelectV2) == null ? void 0 : w.styleOverrides) != null && y.defaultRoot && typeof ((F = (E = (L = l.components) == null ? void 0 : L.SelectV2) == null ? void 0 : E.styleOverrides) == null ? void 0 : F.defaultRoot) == "function" ? (C = (g = (V = l.components) == null ? void 0 : V.SelectV2) == null ? void 0 : g.styleOverrides) == null ? void 0 : C.defaultRoot({
    ownerState: o,
    theme: l
  }) : (r = (n = (a = l.components) == null ? void 0 : a.SelectV2) == null ? void 0 : n.styleOverrides) == null ? void 0 : r.defaultRoot, W = (i) => () => {
    !e.multiple && !e.disableDeselect && i === e.value && !d && e.onChange({ target: { value: "" } });
  };
  function T(i, c) {
    var f;
    const { multiple: m } = e;
    return Array.isArray(i) && m ? i.map((v) => {
      var x;
      return s ? c.find(
        (h) => h === v
      ) : (x = c.find(
        (h) => h.value === v
      )) == null ? void 0 : x.label;
    }).filter(Boolean).join(", ") : s ? i : (f = c.find((S) => i === S.value)) == null ? void 0 : f.label;
  }
  function A(i) {
    return i === null ? "" : i;
  }
  const O = q(t);
  return d ? /* @__PURE__ */ u.createElement(p, { size: t, ...e }) : /* @__PURE__ */ u.createElement(
    Z,
    {
      fullWidth: e.fullWidth,
      disabled: e.disabled,
      sx: { ...b }
    },
    e && e.label && /* @__PURE__ */ u.createElement(
      X,
      {
        id: `${e.id}-label`,
        error: e.error,
        disabled: e.disabled,
        required: e.required
      },
      e.label
    ),
    /* @__PURE__ */ u.createElement(
      H,
      {
        id: e.id,
        labelId: `${e.id}-label`,
        value: A(e.value),
        error: e.error,
        required: e.required,
        disabled: e.disabled,
        onChange: e.onChange,
        renderValue: (i) => T(i, e.menuItems),
        fullWidth: e.fullWidth,
        size: O,
        inputProps: {
          "data-testid": `${e.id}-input`,
          size: O,
          // for the Select icon,
          "aria-label": e["aria-label"]
        },
        MenuProps: {
          "data-testid": `${e.id}-menu`,
          classes: { paper: e.menuClassName },
          // Specifies how close to the edge of the window the menu/popover can appear; defaults to 16px if null
          marginThreshold: l.typography.htmlFontSize
        },
        multiple: e.multiple,
        onFocus: e.onFocus,
        onBlur: e.onBlur
      },
      e.menuItems.map(
        (i) => $({
          option: i,
          multiple: e.multiple,
          handleMenuItemClick: W
        })
      )
    ),
    e.helperText && /* @__PURE__ */ u.createElement(
      J,
      {
        component: "label",
        error: e.error,
        disabled: e.disabled,
        "data-testid": `${e.id}-helper-text`
      },
      e.helperText
    )
  );
}
function Y(t, e) {
  const l = t.toLowerCase().indexOf(e.toLowerCase());
  if (l < 0)
    return [
      {
        text: t,
        highlight: !1
      }
    ];
  const d = t.substring(0, l), s = t.substring(l, l + e.length), o = t.substring(l + e.length);
  return [
    {
      text: d,
      highlight: !1
    },
    {
      text: s,
      highlight: !0
    },
    {
      text: o,
      highlight: !1
    }
  ];
}
function z(t, e, l) {
  const d = Y(t, e);
  let s = e === t;
  return /* @__PURE__ */ u.createElement(u.Fragment, null, d.map((o, b) => /* @__PURE__ */ u.createElement(
    "span",
    {
      key: b,
      style: {
        fontWeight: o.highlight && !s ? 700 : l.typography.body1.fontWeight
      }
    },
    o.text
  )));
}
const p = ({ size: t = "default", ...e }) => {
  var C;
  const l = P(), [d, s] = _("Open"), o = e.menuItems && e.menuItems.length > 0 && typeof e.menuItems[0] == "string";
  function b(a, n = []) {
    if (a === "") return null;
    if (!o) {
      const r = W(a, n);
      if (r) return r;
    }
    return a;
  }
  function W(a, n) {
    const i = Array.isArray(a) && a.length > 0 && typeof a[0] == "string";
    return typeof a == "string" ? n.find(
      (f) => f.value === a
    ) : i ? e.menuItems.filter(
      (m) => a.includes(m.value)
    ) : null;
  }
  const T = q(t), A = T === "small", [O, I] = _(!1), [w, y] = _(!1), L = 6, E = 8, F = E - 1, V = e.multiple && ((C = e.value) == null ? void 0 : C.length) > 0 || !e.multiple && e.value;
  let g = (O || w) && V ? L : 0;
  return A ? g += F : g += E, /* @__PURE__ */ u.createElement(
    N,
    {
      id: e.id,
      options: e.menuItems,
      disabled: e.disabled,
      fullWidth: e.fullWidth,
      multiple: e.multiple,
      disableCloseOnSelect: e.multiple,
      readOnly: e.readOnly,
      renderInput: ({ inputProps: a, InputProps: n, ...r }) => /* @__PURE__ */ u.createElement(
        k,
        {
          ...r,
          autoFocus: e.autoFocusAndOpen,
          label: e.label,
          helperText: e.helperText,
          error: e.error,
          required: e.required,
          fullWidth: e.fullWidth,
          disabled: e.disabled,
          inputProps: {
            ...a,
            "data-testid": `${e.id}-input`
          },
          InputProps: {
            ...n,
            endAdornment: /* @__PURE__ */ u.createElement(u.Fragment, null, e.loading ? /* @__PURE__ */ u.createElement(
              j,
              {
                sx: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                  right: l.spacing(g),
                  // Since each row of the input is 40px in height for default size, set the height of spinner's box so that it can center correctly
                  height: A ? l.spacing(3) : l.spacing(5),
                  width: l.spacing(3)
                }
              },
              /* @__PURE__ */ u.createElement(M, { size: "md" })
            ) : null, n.endAdornment)
          }
        }
      ),
      value: b(e.value, e.menuItems),
      onChange: e.onChange,
      inputValue: e.inputValue,
      onInputChange: e.onInputChange,
      renderOption: (a, n, { inputValue: r }) => {
        let i = "", c;
        return typeof n == "string" ? i = n : (i = n.label, c = n.description && z(n.description, r, l)), $({
          option: n,
          multiple: e.multiple,
          elementProps: a,
          labelNode: z(i, r, l),
          descriptionNode: c
        });
      },
      renderTags: (a, n) => a.map((r, i) => {
        var f;
        const { key: c, ...m } = n({ index: i });
        return typeof r == "string" ? /* @__PURE__ */ u.createElement(
          D,
          {
            key: c,
            label: r,
            onDelete: m.onDelete
          }
        ) : /* @__PURE__ */ u.createElement(
          D,
          {
            key: c,
            label: r.label,
            onDelete: m.onDelete,
            icon: "showIconInChip" in r && r.showIconInChip ? (f = r.endIcon) == null ? void 0 : f.iconName : void 0
          }
        );
      }),
      isOptionEqualToValue: (a, n) => typeof a == "string" ? a === n : a.value === n.value,
      slotProps: {
        paper: {
          className: e.menuClassName
        },
        popper: {
          "data-testid": `${e.id}-menu`
        },
        clearIndicator: {
          "aria-label": "Clear All"
        },
        popupIndicator: { "aria-label": "Popup Indicator" }
      },
      clearIcon: /* @__PURE__ */ u.createElement(B, { title: "Clear all" }, /* @__PURE__ */ u.createElement(Q, null)),
      popupIcon: /* @__PURE__ */ u.createElement(B, { title: d }, /* @__PURE__ */ u.createElement(K, null)),
      noOptionsText: "No matches",
      clearText: "",
      openText: "",
      closeText: "",
      openOnFocus: e.autoFocusAndOpen,
      onOpen: () => s("Close"),
      onClose: () => s("Open"),
      onFocus: (a) => {
        var n;
        y(!0), (n = e.onFocus) == null || n.call(e, a);
      },
      onBlur: (a) => {
        var n;
        y(!1), (n = e.onBlur) == null || n.call(e, a);
      },
      onMouseOver: () => I(!0),
      onMouseOut: () => I(!1),
      filterOptions: (a, n) => a.filter((r) => {
        var i, c, m, f, S, v, x, h;
        return typeof r == "string" ? e.filterType === "startsWith" ? r.toLowerCase().startsWith((i = n.inputValue) == null ? void 0 : i.toLowerCase()) : r.toLowerCase().includes((c = n.inputValue) == null ? void 0 : c.toLowerCase()) : e.filterType === "startsWith" ? r.label.toLowerCase().startsWith((m = n.inputValue) == null ? void 0 : m.toLowerCase()) || ((S = r.description) == null ? void 0 : S.toLowerCase().startsWith((f = n.inputValue) == null ? void 0 : f.toLowerCase())) : r.label.toLowerCase().includes((v = n.inputValue) == null ? void 0 : v.toLowerCase()) || ((h = r.description) == null ? void 0 : h.toLowerCase().includes((x = n.inputValue) == null ? void 0 : x.toLowerCase()));
      }),
      loading: e.loading,
      size: T
    }
  );
};
export {
  Q as C,
  me as S,
  z as h
};
